module.exports = __webpack_public_path__ + "static/img/approvalBg.17159412.png";